import React from "react"
import PrivacyPolicy from "@views/privacy-policy"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Privacy Policy"
      keywords={[
        `engineid`,
        `privacy policy`,
      ]}
    />
    <PrivacyPolicy />
  </div>
)

export default IndexPage
